module.exports = __webpack_public_path__ + "static/5-9dee4641d1e5737598a7a2dddfcb5cf5.png";